import React from 'react';
import ServiceListItem from '../ServiceListItem';
import JsxHelper from '../../Helpers/JsxHelper';
import LookupText from '../../Elements/LookupText';
import TabListTableCellWidthEnum from '../../Enums/TabListTableCellWidthEnum';

// Used for both Phone (TypeCode 2) and Video (TypeCode 3) service types
export default class PhoneServiceItem extends ServiceListItem {
  static FieldsToShowInListTable = [
    ...ServiceListItem.generalTab,
    {
      tabName: 'ProgramDetails',
      tabLabel: 'Program Details',
      icon: 'fa-solid fa-briefcase',
      data: [
        { name: (item) => JsxHelper.YesNo(item.InteractionRequired), label: 'Is Interaction Required?' },
        { name: 'ProductOrServiceInquiry', label: 'Product or Service Inquiry?' },
        { name: '-', label: 'Program Approach' },
        { name: (item) => Array.isArray(item.B2borB2c) ? item.B2borB2c.join(', ') : (item.B2borB2c || ''), label: 'B2B or B2C?' },
        { name: (item) => JsxHelper.YesNo(item.CallerIdNeeded), label: "Does the Client's Phone Have Caller ID?" },
        { name: '-', label: 'B2B Approach' },
        { name: (item) => JsxHelper.YesNo(item.FictiosWebsiteCreationNeeded), label: 'Fictious Website Creation Needed' },
        { name: (item) => JsxHelper.YesNo(item.IsBusinessInformationRequired), label: 'Is Business Information Required' },
        { name: 'BusinessInformationDescription', label: 'If Yes, please describe' },
        { name: '-', label: 'B2C Demographics' },
        { name: 'MinAge', label: 'Minimum Age' },
        { name: 'MaxAge', label: 'Maximum Age' },
        { name: 'OtherDemographicRequirements', label: 'Other Demographic Requirements' },
      ],
    },
    {
      tabName: 'Validation',
      tabLabel: 'Validation',
      icon: 'fa-solid fa-check-circle',
      data: [
        { name: 'NumScreenshotsRequired', label: 'Number of Screenshots Required' },
        { name: (item) => Array.isArray(item.SmsweChatWhatsappScreenshots) ? item.SmsweChatWhatsappScreenshots.join(', ') : (item.SmsweChatWhatsappScreenshots || ''), label: 'SMS, We Chat, or WhatsApp Screenshots Required?' },
        { name: (item) => JsxHelper.YesNo(item.VoicemailTimeStampScreenshot), label: 'Voicemail Time Stamp Screenshot' },
        { name: 'NumCallAttemptsPerEval', label: 'No. of Call Attempts per Evaluation' },
        { name: 'OtherPhotosDesc', label: 'Describe other Photographs Required', width: TabListTableCellWidthEnum.TwoLines },
      ],
    },
    {
      tabName: 'Questionnaire',
      tabLabel: 'Questionnaire',
      icon: 'fa-solid fa-clipboard-question',
      data: [
        { name: 'NumClosedQuestions', label: 'No. Closed Questions' },
        { name: 'NumOpenQuestions', label: 'No. Simple Text Questions' },
        { name: 'NumNarrativeQuestions', label: 'No. Narrative Questions' },
        { name: (item) => JsxHelper.YesNo(item.QuestionnaireProvided), label: 'Questionnaire Provided by Client?' },
        { name: (item) => JsxHelper.YesNo(item.TranslationProvided), label: 'Translation of Questionnaire Provided by Client?' },
        { name: (item) => <LookupText lookupId={21} value={item.DataCaptureMethodCode} />, label: 'Data Capture Method' },
        { name: 'OtherDataCaptureMethod', label: 'Other Data Capture Method Description' },
        { name: (item) => JsxHelper.YesNo(item.GuidelinesProvided), label: 'Guidelines Provided by Client?' },
      ],
    },
    {
      tabName: 'Purchase',
      tabLabel: 'Purchase',
      icon: 'fa-solid fa-cart-shopping',
      data: [
        { name: (item) => JsxHelper.YesNo(item.PhonePurchaseRequired), label: 'Over the Phone Purchase Required?' },
        { name: 'PurchaseDesc', label: 'Please Describe Purchase', width: TabListTableCellWidthEnum.TwoLines },
        { name: (item) => JsxHelper.YesNo(item.ReimbursementRequired), label: 'Reimbursement Requirement?' },
        { name: (item) => JsxHelper.YesNo(item.PurchaseReimbursed), label: 'Purchase Reimbursed by Client?' },
        { name: (item) => JsxHelper.YesNo(item.PurchaseIncluded), label: 'Purchase NOT Reimbursed by BARE or Client?' },
      ],
    },
    ...ServiceListItem.commonEndTabs,
  ];
}
